import { useEffect } from "react";
import T from "../../theme";
import { Icon } from "./Icon";
import { useIsMobile } from "../../hooks/useIsMobile";

export const Toast = ({ msg, type, onClose }) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const ok = type === "success";
  return (
    <div style={{
      position: "fixed",
      bottom: isMobile ? 20 : 80,
      right: isMobile ? 12 : 24,
      left: isMobile ? 12 : "auto",
      zIndex: 9999,
      background: T.card,
      border: `1px solid ${ok ? T.successBorder : T.dangerBorder}`,
      borderLeft: `4px solid ${ok ? T.success : T.danger}`,
      color: ok ? T.successText : T.dangerText,
      padding: "12px 18px",
      borderRadius: T.radiusMd,
      fontSize: 14,
      display: "flex", alignItems: "center", gap: 8,
      boxShadow: T.shadowLg,
      animation: "slideUp 0.25s ease",
      fontWeight: 500,
    }}>
      <Icon name={ok ? "check" : "alert"} size={15} color={ok ? T.success : T.danger} />
      {msg}
    </div>
  );
};
